import {
    AssignedUser,
    ListingDetail,
} from '@deltek/specification-client/core/Models/listing'
import { User } from '@deltek/specification-client/core/Models/user'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'
import PopupButton from './PopupButton'

const useStyles = makeStyles((theme: Theme) => ({
    propertiesHeaderUpper: {
        height: '11%',
    },
    propertiesHeaderUpperItem: {
        padding: theme.spacing(1.25),
    },
    propertiesHeaderUpperLeftSide: {
        ...theme.typography.h1,
        color: '#05676E',
    },
    propertiesHeaderUpperRightSideTitle: {
        ...theme.typography.subtitle2,
        color: '#5E5F61',
        fontWeight: 'normal',
    },
    propertiesHeaderUpperRightSideValue: {
        ...theme.typography.subtitle2,
        color: '#5E5F61',
    },
    fullWidth: {
        width: '100%',
    },
    flexContainer: {
        display: 'flex',
    },
    categories: {
        width: '64px',
    },
    categoriesValue: {
        width: 'calc(100% - 64px)',
    },
    family: {
        width: '48px',
    },
    familyValue: {
        width: 'calc(100% - 48px)',
    },
}))

interface ListingDetailsUserAssignmentProps {
    loading?: boolean
    onCancelClick: VoidFunction
    productInfo?: Partial<ListingDetail> | null
    buttonLabel?: string | undefined
    isDeltekAdmin: boolean
    isOnEditMode: boolean
    isPopoverOpen: boolean
    onChange?: (
        /** Event source */
        event: React.ChangeEvent<{}>,
        /** New selection */
        value: string[]
    ) => void
    poupHeaderText: string
    handleBPMUsersChange?: (
        /** Event source */
        users: Partial<AssignedUser>[],
        /** New selection */
        valid: boolean
    ) => void
    handleDeltekUsersChange?: (
        /** Event source */
        users: Partial<AssignedUser>[],
        /** New selection */
        valid: boolean
    ) => void
    users: Partial<User>[]
    assignedBPMLabel?: string
    assignedDeltekLabel?: string
    canEdit: boolean
    buttonVariant: 'BPM' | 'Deltek'
}

const ListingDetailsUserAssignment: React.FC<ListingDetailsUserAssignmentProps> = ({
    onCancelClick,
    productInfo,
    isDeltekAdmin,
    buttonLabel,
    isPopoverOpen,
    isOnEditMode,
    poupHeaderText,
    users,
    handleBPMUsersChange,
    handleDeltekUsersChange,
    assignedBPMLabel,
    assignedDeltekLabel,
    canEdit,
    buttonVariant,
}) => {
    const classes = useStyles()

    const [selectedUsers, setSelectedUsers] = React.useState<
        Partial<AssignedUser>[]
    >([])

    const onAdminChange = (
        _unusedEvent: React.ChangeEvent<{}>,
        newSelectedItems: Partial<AssignedUser>[]
    ): void => {
        setSelectedUsers(newSelectedItems)
        if (buttonVariant === 'BPM') {
            handleBPMUsersChange?.(newSelectedItems, true)
        } else {
            handleDeltekUsersChange?.(newSelectedItems, true)
        }
    }

    React.useEffect(() => {
        if (!isOnEditMode) {
            if (buttonVariant === 'BPM') {
                const bpmUsers = productInfo?.assignedBPMUsers ?? []
                setSelectedUsers(bpmUsers)
                handleBPMUsersChange?.(bpmUsers, true)
            } else {
                const deltekUsers = productInfo?.assignedDeltekUsers ?? []
                setSelectedUsers(deltekUsers)
                handleDeltekUsersChange?.(deltekUsers, true)
            }
        }
    }, [
        isOnEditMode,
        assignedBPMLabel,
        assignedDeltekLabel,
        buttonVariant,
        productInfo,
        handleDeltekUsersChange,
        handleBPMUsersChange,
    ])

    const filteredUsers = React.useMemo(() => {
        return users?.filter(
            (e) => !selectedUsers.map((e2) => e2.id).includes(e.id)
        )
    }, [selectedUsers, users])

    return (
        <GridContainer
            data-testid="listingHeaderAssignment"
            className={classes.propertiesHeaderUpper}
            item
        >
            <GridItem>
                <PopupButton
                    name="assign"
                    buttonVariant={buttonVariant}
                    items={filteredUsers}
                    selectedItems={selectedUsers}
                    onChange={onAdminChange}
                    isPopoverOpen={isPopoverOpen}
                    isOnEditMode={isOnEditMode}
                    isDeltekAdmin={isDeltekAdmin}
                    canEdit={canEdit}
                />
            </GridItem>
        </GridContainer>
    )
}
export default ListingDetailsUserAssignment
